module.exports = __webpack_public_path__ + "static/media/huid.f6d06d18.svg";